// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3gYmi","question":"Question_question__1KnO6","description":"Question_description__3cI8x"};